import { formatInr, MONEY_CLASSNAME } from '@/lib/money';
import RateMovement from './RateMovement';

export default function MetalTicker({ rates }) {
  if (!rates?.gold?.rate_per_gram || !rates?.silver?.rate_per_gram) {
    return (
      <div className="bg-black/60 border-b border-white/5 h-9 flex items-center justify-center" data-testid="metal-ticker-unavailable">
        <span className="text-xs font-mono text-amber-400">Live rate temporarily unavailable</span>
      </div>
    );
  }

  const isLive = ['ibja_manual', 'ibja_official_dated'].includes(rates.gold?.source);

  return (
    <div className="bg-black/60 border-b border-white/5 overflow-hidden" data-testid="metal-ticker">
      <div className="flex items-center h-9 animate-marquee whitespace-nowrap">
        {[...Array(4)].map((_, i) => (
          <div key={i} aria-hidden={i > 0} className="flex items-center gap-12 px-8">
            <div className="flex items-center gap-2">
              <span className="text-xs font-mono font-medium text-muted-foreground tracking-wide">GOLD 24K</span>
              <span className={`${MONEY_CLASSNAME} text-xs font-semibold text-foreground`}>
                {formatInr(rates.gold?.rate_per_gram) || 'Unavailable'}/g
              </span>
              <RateMovement rate={rates.gold} compact />
              {isLive && <span className="w-1.5 h-1.5 rounded-full bg-green-500 live-pulse" />}
            </div>
            <span className="text-border/30">|</span>
            <div className="flex items-center gap-2">
              <span className="text-xs font-mono font-medium text-muted-foreground tracking-wide">SILVER 999</span>
              <span className={`${MONEY_CLASSNAME} text-xs font-semibold text-foreground`}>
                {formatInr(rates.silver?.rate_per_gram) || 'Unavailable'}/g
              </span>
              <RateMovement rate={rates.silver} compact />
              {isLive && <span className="w-1.5 h-1.5 rounded-full bg-green-500 live-pulse" />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
